import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '../components/pages/MainPage'
import ThankYouPage from '../components/summary/ThankYouPage'
import ErrorPage from '../components/summary/ErrorPage'
import SummaryPage from '../components/summary/SummaryPage'
import systemConst from '@SYSTEM_CONSTANTS'

import PaymentTabs from "@/components/pages/payments/PaymentTabs.vue";
import OneTimePaymentStepOne from '@/components/pages/payments/one-time/StepOne.vue'
import OneTimePaymentStepTwo from '@/components/pages/payments/one-time/StepTwo.vue'
import MonthlyPaymentStepOne from '@/components/pages/payments/monthly/StepOne.vue'
import MonthlyPaymentStepTwo from '@/components/pages/payments/monthly/StepTwo.vue'


const routes = [
    {
        path: '/',
        component: MainPage,
        children: [
            {
                path: '',
                component: PaymentTabs,
                meta: {
                    title: 'Wpłacam i pomagam - ' + systemConst.SYSTEM_NAME
                },
                children: [{
                    path: '',
                    name: 'OneTimePaymentStepOne',
                    component: OneTimePaymentStepOne,
                    meta: {
                        title: 'Wpłacam i pomagam jednorazowo - ' + systemConst.SYSTEM_NAME,
                    },
                },
                {
                    path: '/co-miesiac/',
                    name: 'MonthlyPaymentStepOne',
                    component: MonthlyPaymentStepOne,
                    meta: {
                        title: 'Wpłacam i pomagam co miesiąc - ' + systemConst.SYSTEM_NAME,
                    }
                }]
            },
            {
                path: '/jednorazowo/krok-2',
                component: OneTimePaymentStepTwo,
                meta: {
                    title: 'Wpłacam i pomagam jednorazowo - krok II - ' + systemConst.SYSTEM_NAME,
                    requiredFieldsInSessionStorage: ['payment_type', 'payment_gateway', 'amount'],
                },
            },
            {
                path: '/co-miesiac/krok-2',
                component: MonthlyPaymentStepTwo,
                meta: {
                    title: 'Wpłacam i pomagam co miesiąc - krok II - ' + systemConst.SYSTEM_NAME,
                    requiredFieldsInSessionStorage: ['payment_type', 'payment_gateway', 'amount'],
                },
            }
        ]
    },
    {
        path: '/dziekujemy',
        component: ThankYouPage,
        meta: {
            title: 'Dziękujemy! - ' + systemConst.SYSTEM_NAME,
            requiredFieldsInSessionStorage: ['valid_payment_form']
        }
    },
    {
        path: '/blad',
        component: ErrorPage,
        meta: {
            title: 'Nie udało się dokończyć płatności - ' + systemConst.SYSTEM_NAME,
            requiredFieldsInSessionStorage: ['valid_payment_form']
        }
    },
    {
        path: '/podsumowanie',
        component: SummaryPage,
        meta: {
            title: 'Podsumowanie - ' + systemConst.SYSTEM_NAME,
            requiredFieldsInSessionStorage: ['valid_payment_form']
        }
    }
]

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_ROUTER_BASE,
    routes
})

function hasQueryParams (route) {
    return !!Object.keys(stripSpecialQueryVariables(route.query)).length
}

function stripSpecialQueryVariables (query) {
    const specialQueryVariables = ['amount', 'payment_type'];
    let newQuery = {...query};

    specialQueryVariables.forEach(v => {
        delete newQuery[v];
    })

    return newQuery;
}

router.beforeEach((to, from, next) => {
    if (to.path !== '/') {
        const oldUrls = {
            '/krok-1': '/',
            '/krok-2': '/',
            '/krok-3': '/',
        }

        if (oldUrls[to.path]) {
            next(oldUrls[to.path])
        }

        if (Array.isArray(to.meta.requiredFieldsInSessionStorage)) {
            to.meta.requiredFieldsInSessionStorage.forEach((field) => {
                if (window.sessionStorage.getItem(field) === null || window.sessionStorage.getItem(field) === 'undefined') {
                    router.push({ path: '/' })
                }
            })
        }
    }

    document.title = to.meta.title

    if (!hasQueryParams(to) && hasQueryParams(from)) {
        next({ path: to.path, query: stripSpecialQueryVariables(from.query), replace: false })
    } else {
        next()
    }
})

export default router
